/**
 * Application Configuration
 *
 * Centralized configuration for the application.
 * API_BASE_URL is determined in the following order:
 * 1. REACT_APP_API_URL environment variable
 * 2. Default fallback (http://localhost:10001)
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:10001';

export const APP_CONFIG = {
    API_BASE_URL,
    // Add other config constants here
};
